const BaseError = require('make-error').BaseError;

class ConfigurationError extends BaseError {
    constructor(errorMessage='Invalid configuration') {
        super(errorMessage);
    }
}

module.exports = ConfigurationError;